import { GetServerSideProps } from "next";
import { getAgentNews } from "../../../services/api/agent";
import { getClubNews } from "../../../services/api/clubs";
import { getLeagueNews } from "../../../services/api/league";
import { getManagerNews } from "../../../services/api/manager";
import { getNewsList } from "../../../services/api/news";
import { getPlayerNews } from "../../../services/api/player";
import { API } from "../../../services/api/types";
import slugify from "../../../utils/slugify";

type GetServerSidePropsParams = {
  slug: string;
  id: string;
};

export const getServerSideProps: GetServerSideProps<
  {},
  GetServerSidePropsParams
> = async (context) => {
  const { res } = context;
  const { slug, id } = context.params!;

  let articles;

  switch (slug) {
    case "nyheter":
      articles = await getNewsList({ limit: 20 });
      break;

    case "klubbar":
      articles = await getClubNews(id, { limit: 20 });
      break;

    case "spelare":
      articles = await getPlayerNews(id, { limit: 20 });
      break;

    case "agenter":
      articles = await getAgentNews(id, { limit: 20 });
      break;

    case "ligor":
      articles = await getLeagueNews(Number(id))({ limit: 20 });
      break;

    case "tranare":
      articles = await getManagerNews(id, { limit: 20 });
      break;

    case "kategori":
      articles = await getNewsList({ limit: 20, category: Number(id) });
      break;

    default:
      break;
  }

  res.setHeader("Content-Type", "text/xml");
  res.write(getRssXml(context.resolvedUrl, articles?.data));
  res.end();

  return { props: {} };
};

const getRssXml = (uri: string, articles?: API.Article[]) => {
  return `<?xml version="1.0" encoding="UTF-8" ?>
  <rss version="2.0" xmlns:atom="http://www.w3.org/2005/Atom" xmlns:dc="http://purl.org/dc/elements/1.1/">
  <channel>
    <title><![CDATA[Fotbolltransfers.com]]></title>
    <link>https://fotbolltransfers.com/</link>
    <atom:link href="https://fotbolltransfers.com${uri}" rel="self" type="application/rss+xml"/>
    <atom:link rel="hub" href="https://pubsubhubbub.appspot.com/" />
    <description><![CDATA[Läs de senaste nyheterna från Fotbolltransfers]]></description>
    <language>sv</language>
    ${articles?.map((a) => newsItemRssXml(a)).join("\n")}
  </channel>
</rss>`;
};

const newsItemRssXml = (article: API.Article) => {
  return `  <item xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:media="http://search.yahoo.com/mrss/">
    <title>
      <![CDATA[ ${article.titleShort} ]]>
    </title>
    <link>https://fotbolltransfers.com/nyheter/${slugify(article.title)}/${
    article.id
  }</link>
    <guid>https://fotbolltransfers.com/nyheter/${slugify(article.title)}/${
    article.id
  }</guid>
    <pubDate>${new Date(article.date).toUTCString()}</pubDate>
    <description><![CDATA[ ${article.excerpt} ]]></description>
    <media:thumbnail url="${process.env.NEXT_PUBLIC_ASSET_SERVER_URL}${
    article.imageFull
  }"></media:thumbnail>
  </item>`;
};

const placeHolderPage = () => "";
export default placeHolderPage;
